import Vue from 'vue';

var clipboard = '';

export default {
  data() {
    return {
        payment: {},
        error: null,
        success: false,
        loading: false
    };
  },
  components: {
      VLayout: require('layouts/default/default.vue'),
      VPanel: require('components/panel/panel.vue'),
      VLoading : require('components/loading/loading.vue')
  },
  mounted() {
      let vm = this;
      if(clipboard){
          clipboard.destroy();
      }

      clipboard = new Clipboard('.btn8');
      clipboard.on('success', function(e) {
          toastr.success(vm.$t("payments.detail.permalink_copied"));
          e.clearSelection();
      });

      clipboard.on('error', function(e) {
          toastr.error(vm.$t("payments.detail.permalink_error_in_copy"));
      });
      if(this.$route.params.id){
          this.loading = true;
          this.getPaymentById(this.$route.params.id);
      }
  },
  methods: {
      getPaymentById(id) {
          let vm = this;
          //TODO Create service for getting payment
          Vue.$http.get('/payments/' + id)
              .then((response) => {
                  if (response.status === 200) {
                      vm.payment = response.data.payment;
                      vm.payment.permalink = window.location.protocol + "//" + window.location.host + "/#/p/"+ vm.payment.permalink;
                      vm.loading = false;
                  }
              })
              .catch((error) => {
                  if (error.response) {
                      //vm.error = error.response.data.msg;
                      toastr.error(error.response.data.msg);
                  }
              });
      },
      delete_payment (id) {
          let vm = this;
          swal({
                  title: "Are you sure?",
                  text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>You will not be able to recover this property</div>',
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonClass: "btn-warning",
                  confirmButtonText: 'Yes, delete it!',
                  closeOnConfirm: false,
                  html: true
              },
              function() {
                  $(".cancel").addClass("disabled");
                  $(".confirm").addClass("disabled");
                  $(".pulseWarning").hide();
                  $("#loading1").show();
                  //TODO Create Service for delete payment
                  Vue.$http.delete('/payments/'+id).then((response) => {
                      if (response.status === 200) {
                          $(".cancel").removeClass("disabled");
                          $(".confirm").removeClass("disabled");
                          swal("Deleted!", "Your payment has been deleted!", "success");
                          vm.loading = false;
                          Vue.router.push({
                              name: 'payments.index',
                          });
                      }
                  }).catch((error) => {
                      if (error.response) {
                          $(".cancel").removeClass("disabled");
                          $(".confirm").removeClass("disabled");
                      }
                  });

              });
      },
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/payments/detail/detail.js